/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-03 14:30:16
 */
const state = {
  sysType: null,
  navTitle: ''
}
const mutations = {
  SET_SYSTYPE (state, type) {
    state.sysType = type
  },
  SET_NAVTITLE (state, text) {
    state.navTitle = text
  }
}
const actions = {
  genaraterSys (content, type) {
    content.commit('SET_SYSTYPE', type)
  },
  setNavTitle (content, title) {
    content.commit('SET_NAVTITLE', title)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uiPermisson.js